import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  MapPin,
  UserRoundCheck,
  Phone,
  MapPinHouse,
  Trash2,
} from "lucide-react";
import "./AddressCard.css";
import "./AddressCardList.css";
import { deleteAddress } from "../../services/addressService";

import Swal from "sweetalert2";


export default function AddressCard({
  address,
  onEdit,
  onDelete,
  refreshList,
}) {
  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "آیا شما مطمئن هستید؟",
      text: ".پس از حذف امکان بازگشت دوباره وجود ندارد",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "تایید",
      cancelButtonText: "خیر",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await deleteAddress(address.id);

        Swal.fire({
          title: "!حذف",
          text: ".آدرس مورد  نظر با موفقیت حذف گردید",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        refreshList(); // reload addresses
      } catch (error) {
        Swal.fire({
          title: "خطا",
          text: ".شما با خطا مواجه شده اید",
          icon: "error",
        });
      }
    }
  };

  return (
    <>
      <div className="address-card">
        <h4 className="address-title">
          <span className="title">
            <MapPin color="#832865" size={24} strokeWidth={0.75} />
            {address.province} - {address.city} {" - "}
             {address.address}</span>

          <div className="address-actions" onClick={handleDelete}>
            <Trash2 color="#fa0000" strokeWidth={1.75} size={20} />
          </div>
        </h4>
        {/* <h4 className="address-title">
          <span className="title"> {address.address}</span>

          <div className="address-actions" onClick={handleDelete}>
            <Trash2 color="#fa0000" strokeWidth={1.75} size={20} />
          </div>
        </h4> */}

        {/* <p>
          <MapPin color="#832865" size={24} strokeWidth={0.75} />
          <span className="title"></span>
          {address.province} - {address.city}
        </p> */}

        <p>
          <Phone size={20} color="#777" strokeWidth={0.5} />
          <span className="title">{address.mobile}</span>
        </p>

        <p>
          <UserRoundCheck size={20} color="#777" strokeWidth={0.5} />
          <span className="title">
            {address.fname} {address.lname}
          </span>
        </p>

        <p>
          <MapPinHouse size={20} color="#777" strokeWidth={0.5} />

          <span className="title-field"> کد پستی: </span>
          <span className="title">
            {address.postal_code ? address.postal_code : "ثبت نشده "}
          </span>
        </p>
      </div>
    </>
  );
}
